import {
    apiActividadesEconomicasActividadesCatalogo,
    apiActividadesEconomicasActividadesSecundarias,
    apiActividadesEconomicasGirosPrincipales,
} from "../settings/apiConfig";
import { createContext, useContext, useEffect, useState } from "react";

import InfoIcon from "@material-ui/icons/Info";
import { Tooltip } from "@material-ui/core";
import { useRequest } from "./RequestContext";

export const ActividadesEconomicasContext = createContext();

export const ActividadesEconomicasProvider = (props) => {
    const { Get } = useRequest();

    const [lstActividadesEconomicas, setLstActividadesEconomicas] = useState([]);
    const [lstActividadesSecundarias, setLstActividadesSecundarias] = useState([]);
    const [lstActividadesCatalogo, setLstActividadesCatalogo] = useState([]);

    const handleClickObtenerActividadesEconomicas = async () => {
        const response = await CGetGirosPrincipales();
        if (response.Code === 0) {
            setLstActividadesEconomicas(
                response.Result.map((x) => ({
                    ...x,
                    tool: (
                        <Tooltip title={x.sActividadesIncluye} arrow placement="top">
                            <InfoIcon color="secondary" />
                        </Tooltip>
                    ),
                }))
            );
        } else {
            setLstActividadesEconomicas([]);
        }
    };

    const handleClickObtenerActividadesSecundarias = async () => {
        const response = await CGetActividadesSecudariasServicio();
        if (response.Code === 0) {
            setLstActividadesSecundarias(response.Result);
        } else {
            setLstActividadesSecundarias([]);
        }
    };

    const handleClickObtenerActividadesCatalogo = async () => {
        const response = await CGetActividadesSecudariasCatalogo();
        if (response.Code === 0) {
            setLstActividadesCatalogo(response.Result);
        } else {
            setLstActividadesCatalogo([]);
        }
    };

    const CGetGirosPrincipales = async () => {
        const payload = {
            url: apiActividadesEconomicasGirosPrincipales,
        };

        return await Get(payload);
    };

    const CGetActividadesSecudariasServicio = async () => {
        const payload = {
            url: apiActividadesEconomicasActividadesSecundarias,
        };

        return await Get(payload);
    };

    const CGetActividadesSecudariasCatalogo = async () => {
        const payload = {
            url: apiActividadesEconomicasActividadesCatalogo,
        };

        return await Get(payload);
    };

    useEffect(() => {
        handleClickObtenerActividadesEconomicas();
        //handleClickObtenerActividadesSecundarias();
        handleClickObtenerActividadesCatalogo();
        // eslint-disable-next-line
    }, []);

    return (
        <ActividadesEconomicasContext.Provider
            value={{
                lstActividadesEconomicas,
                lstActividadesSecundarias,
                lstActividadesCatalogo,
                handleClickObtenerActividadesEconomicas,
                handleClickObtenerActividadesSecundarias,
                handleClickObtenerActividadesCatalogo,
            }}
        >
            {props.children}
        </ActividadesEconomicasContext.Provider>
    );
};

export const useActividadesEconomicas = function () {
    return useContext(ActividadesEconomicasContext);
};
